// extracted by css-extract-rspack-plugin
export default {"wrap":"DevExpressLogoFileController_wrap__LEpKe","input":"DevExpressLogoFileController_input__Wu9iJ","img":"DevExpressLogoFileController_img__u5pi6"};